import React from 'react';

const ChatIcon = (props: any) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 17.3333L8.8031 19.8908C8.65472 20.0095 8.45144 20.0326 8.28018 19.9503C8.10892 19.868 8 19.6948 8 19.5048V17.3333H6.66667C5.19391 17.3333 4 16.1394 4 14.6666V6.66665C4.00001 5.1939 5.19392 4 6.66667 4H17.3333C18.8061 4 20 5.1939 20 6.66665V14.6666C20 16.1394 18.8061 17.3333 17.3333 17.3333H12Z"
      stroke={props.color || '#518103'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 8.5H16"
      stroke={props.color || '#518103'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 12.5H16"
      stroke={props.color || '#518103'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ChatIcon;
